export var Options = {
  Daily: 'daily',
  Weekly: 'weekly',
  Monthly: 'monthly',
  Yearly: 'yearly'
};

export var DEFAULT_SCHEDULE = { schedule: Options.Daily, dailyOptions: { every: 1 } };

export var computeDefaultWeeklySchedule = function computeDefaultWeeklySchedule(when) {
  var day = new Date(when).getDay();
  return {
    every: 1,
    days: [day]
  };
};

export var computeDefaultMonthlySchedule = function computeDefaultMonthlySchedule(when) {
  var date = new Date(when);
  var day = date.getDate();
  if (day === 1) {
    return {
      every: 1,
      onOrdinal: 1,
      onSchedule: 'day',
      day: null
    };
  }
  var lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  if (lastDayOfMonth.getDate() === day) {
    return {
      every: 1,
      onOrdinal: -1,
      onSchedule: 'day',
      day: null
    };
  }
  if (day > 28) day = 28;
  return {
    every: 1,
    day: day,
    onSchedule: null,
    onOrdinal: null
  };
};

export var computeDefaultYearlySchedule = function computeDefaultYearlySchedule(when) {
  var date = new Date(when);
  var day = date.getDate();
  // handle leap year
  var month = date.getMonth() + 1;
  if (month === 2 && day > 28) day = 28;
  return {
    every: 1,
    day: day,
    month: month
  };
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/When/RecurrencyDetails/utils.js
// module id = 489
// module chunks = 0